import React, { lazy } from 'react';

import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('@pages/landing/Home'));

export const HomeRoutes: RouteObject[] = [
  {
    path: '/',
    element: (
      <React.Suspense>
        <Home />
      </React.Suspense>
    ),
  },
];
